import React, { Component } from 'react';
import { clock, cross } from '../../../Images/Images';

export default class MarkDetail extends Component {
  render() {
    return (
      <div className="markContainerCell">
        <div className="markCell">
          <div className="markTimeCell">
            <img className="clockIcon" src={clock} alt="icon"></img>
            <p className="markTimeLabel" key={this.props.mark.idx}>{this.props.mark.time}</p>
            <img className="closeIcon" onClick={ e => this.props.onDeleteMark(this.props.mark)} src={cross} alt="icon" ></img>
          </div>
          <div className="markCointainerDesc">
            {/* <div className="txtMarkDescriptionCell">
              <div className="txtMarkDescription">{"Descripción"}</div>
            </div> */}
          </div>
        </div>
      </div>
    );

  }
}



// WEBPACK FOOTER //
// ./src/components/workSpace/floatingWindows/MarkDetail.jsx